import { setDetailParams, setSelectedClient } from "../../state/clientMasterSlice"
import {
  faPlus,
  faUser,
  faPenToSquare,
  faGlobe,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks"
import { ConfirmBox, ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { COLUMN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"
import { setIsNewEntry } from "../../state/userMasterSlice"
import { Autocomplete, AutocompleteItem, Button, Checkbox, DatePicker, Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, form, Input, useDisclosure } from "@nextui-org/react"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { parseDate } from "@internationalized/date"

function ClientSubscription() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [itemToDelete, setItemToDelete] = useState("")

  const [formData, setFormData] = useState({
    subId: 0,
    subAmount: "",
    subPoint: "",
    subDate: null,
    clientCode: "",
    isExpire: false
  })
  const [isNewEntry, setIsNewEntry] = useState(true)
  const exportColumns = [
    { uid: "client_code", name: "CLIENT CODE" },
    { uid: "client_name", name: "CLIENT Name" },
    { uid: "subscribe_date", name: "SUB DATE" },
    { uid: "subscription_amount", name: "Amount" },
    { uid: "sbscription_point", name: "Point" },
    { uid: "consume_point", name: "Consume Point" },
  ]

  const getSafeDate = (value) => {
    if (!value || typeof value !== "string") {
      return null;
    }

    // Only accept YYYY-MM-DD
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return null;
    }

    try {
      return parseDate(value);
    } catch {
      return null;
    }
  };
  const {
    isPending: isPendingData,
    isError: isErrorData,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.clientSubscription.getEntryData,
    queryKey: "ClientSunscritionMaster",
  })

  const funLoadData = () => {
    filterData({
      data: {

      }
    })

  }
  useEffect(() => {
    funLoadData();

  }, [])
  const {
    isLoading: isLoadingClient,
    data: clientMastData = [],
  } = useFetchWithBody({
    url: apiRoute.clientSubscription.getClientList,
    queryKey: "ClientList",
  })

  const {
    mutate: funDelete
  } = usePost({
    url: apiRoute.clientSubscription.deleteEntry,
    queryKey: "DeleetClientMaster",
    onSuccessTasks: (data) => {
      itemToDelete("")
      if (data && data.length > 0) {
        if (data[0].ref == 1)
          toast.error("Client can't be delete as it lock", {
            position: "top-center"
          })
        else {
          toast.success("Client deleted", {
            position: "top-center"
          })
        }
      }
      funLoadData();
    }
  })

  const {
    isPending,
    isError,
    mutate: funAddUpdate
  } = usePost({
    url: apiRoute.clientSubscription.addUpdate,
    queryKey: "ClientMaster",
    onSuccessTasks: (data) => {
      toast.success(`Entry ${isNewEntry ? "Inserted" : "Updated"} `, {
        position: "top-center"
      })
      setIsNewEntry(true)
      setFormData({
        subId: 0,
        subAmount: "",
        subPoint: "",
        subDate: null,
        clientCode: "",
        isExpire: false
      })
      funLoadData();

    }
  })


  const columns = [
    {
      name: "ACTIONS",
      uid: "actions",
    },
    { uid: "client_code", name: "CLIENT CODE" },
    { uid: "client_name", name: "CLIENT Name" },
    { uid: "subscribe_date", name: "sub. Date", type: COLUMN_TYPE.date },
    { uid: "subscription_amount", name: "Sub. Amount" },
    { uid: "sbscription_point", name: "Sub. Point" },
    { uid: "consume_point", name: "Con. Point" },
  ]

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "client_code",
    "client_name",
    "subscribe_date",
    "subscription_amount",
    "sbscription_point",
    "consume_point"
  ]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        onOpen()
        setIsNewEntry(true)
        setFormData({
          subId: 0,
          subAmount: "",
          subPoint: "",
          subDate: null,
          clientCode: "",
          isExpire: false
        })
        //navigate(linksUrl.client.createEntry)
      },
      label: "Add Subscription",
    },
  ]

  const handleChange = (e) => {
    const { value, name } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} className="text-lime-600 text-md p-3 bg-lime-50" />,
      onClick: (row) => {
        setIsNewEntry(false)
        const apiDate = row?.subscribe_date; // "2026-08-04T00:00:00.000Z"
        setFormData({
          ...formData,
          subId: row?.subId,
          subAmount: row?.subscription_amount,
          subPoint: row?.sbscription_point,
          subDate: apiDate ? apiDate.split("T")[0] : "", // "2026-08-04"
          clientCode: row?.client_code,
          isExpire: row?.isExpire == 1 ? true : false
        })
        onOpen();
      },
      label: "",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faTrash} className="text-red-600 text-md p-3 bg-red-50" />,
      onClick: (row) => {
        setItemToDelete(row)

      },
      label: "",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]
  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete && itemToDelete != null) {
        funDelete({
          data: {
            sub_id: itemToDelete?.subId,
            client_code: itemToDelete?.client_code
          }
        })
        
      }
    }
    else {
      setItemToDelete("")
    }
  };
  const handleAutoCompleteChange = (val) => {
    setFormData({ ...formData, clientCode: val })
  }
  const handleSubmit = (e) => {
    e.preventDefault();

    funAddUpdate({
      data: {
        subId: formData?.subId,
        subAmount: formData.subAmount,
        clientCode: formData.clientCode,
        subPoint: formData.subPoint,
        subDate: formData.subDate,
        isExpire: formData.isExpire == true ? 1 : 0,
        recStatus: isNewEntry ? 2 : 1
      }
    })
  }
  console.log(formData)
  if (isPending, isPendingData) {
    return <LoadingCard />
  }

  if (isError.isErrorData) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Client Subscription">
        <Drawer isOpen={isOpen} onOpenChange={onOpenChange} placement="right" >
          <DrawerContent>
            {(onClose) => (
              <>
                <DrawerHeader className="flex flex-col gap-1">Drawer Title</DrawerHeader>
                <DrawerBody>
                  <form onSubmit={handleSubmit}>
                    <div className="p-2 font-semibold text-rose-700  bg-red-50 uppercase ">{` ${isNewEntry ? "Add New Subscription" : "Update Subscription"} `} </div>
                    <br />
                    <div className=" w-full flex-wrap md:flex-nowrap  md:mb-0 gap-4">
                      <Autocomplete
                        size="md"
                        name={"clientCode"}
                        label={"Client"}
                        eventResizeFeature={true}
                        selectionMode="single"
                        showScrollIndicators={true}
                        labelPlacement={"outside"}
                        placeholder={""}
                        isRequired={true}
                        isLoading={isLoadingClient}
                        isReadOnly={isNewEntry ? false : true}
                        menuTrigger={"input"}
                        className="max-w-23 font-semibold"
                        classNames={{
                          label: "text-xs text-black font-bold",
                        }}
                        isClearable={false}
                        isVirtualized
                        readonly={isNewEntry ? false : true}
                        defaultItems={
                          clientMastData || []
                        }
                        onSelectionChange={(e) =>
                          handleAutoCompleteChange(e)
                        }
                        variant="bordered"
                        selectedKey={formData.clientCode}

                      >
                        {(list) => (
                          <AutocompleteItem

                            key={list.Client_Code}
                          >
                            {list.Client_Name}
                          </AutocompleteItem>
                        )}
                      </Autocomplete>
                      <DatePicker
                        label="Sub. Date"
                        placeholder=" "
                        className="font-semibold pb-3"
                        labelPlacement="outside"
                        name="SubDate"
                        isRequired
                        variant="bordered"
                        value={getSafeDate(formData.subDate)}
                        onChange={(date) => {
                          setFormData((prev) => ({
                            ...prev,
                            subDate: date ? date.toString() : "",
                          }));
                        }}
                      // isDisabled={isPending}
                      />
                      <Input
                        type="number"
                        label="Amount"
                        className="font-semibold  pb-3"
                        placeholder=" "
                        labelPlacement="outside"
                        name="subAmount"
                        isRequired
                        variant="bordered"
                        value={formData.subAmount}
                        onChange={handleChange}
                      // isDisabled={isPending}
                      />
                      <Input
                        type="number"
                        label="Sub. Point"
                        className="font-semibold  pb-3"
                        placeholder=" "
                        labelPlacement="outside"
                        name="subPoint"
                        isRequired
                        variant="bordered"
                        value={formData.subPoint}
                        onChange={handleChange}
                      // isDisabled={isPending}
                      />

                      <Checkbox size="md"
                        classNames={{ "label": "text-pink-500 text-md font-semibold" }}
                        className="py-1 px-2 mt-2  " color={"danger"} isSelected={formData.isExpire}
                        onValueChange={(val) => setFormData({ ...formData, isExpire: val })} >Is Expire</Checkbox>
                      <div className="my-5 text-center w-full mx-auto flex gap-5 items-center">
                        <Button color="warning" type="submit" size="sm" className="font-semibold" >
                          Submit
                        </Button>
                        <Button color="danger" size="sm" variant="solid" className="font-semibold" onPress={onClose}>
                          Close
                        </Button>
                      </div>
                    </div>
                  </form>
                </DrawerBody>
                {/* <DrawerFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
               
              </DrawerFooter> */}
              </>
            )}
          </DrawerContent>
        </Drawer>
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}

          rowActionBtn={rowActionBtn}
          downloadFileName="Client_Subcription_Master"
          id="Client_Code"
        />
      </MainContainer>
      {(itemToDelete) && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
        />
      )}
    </div>
  )
}

export default ClientSubscription
